import { Button, CalendarInput, Tabs, TextInput, Typography } from 'enable-ui';

import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';

import { CustomTabs } from '../styles/tab';

import { isBefore, parse } from 'date-fns';
import { isNull } from 'lodash';

import { COLOR_CONFIG } from 'constants/color';

import { ClassAbsentModal } from '../components/ClassAbsentModal';
import { LearnResult } from '../components/LearnResult';
import { LessonExercises } from '../components/LessonExercises';
import { SupervisedVideo } from '../components/SupervisedVideo';
import { getLessonExercisesColumn } from '../core/columns';
import { useLessonDetailController } from '../core/controller/lesson-detail';
import { ClassLessonAction, ExerciseContentType, LESSON, LessonAssessmentType } from '../core/enum';
import { getLessonTabs } from '../core/tabs';

export const LessonDetailPage = () => {
  const tabs = getLessonTabs();

  const {
    onTabClick,
    activeKey,
    learnerResult,
    exercises,
    lesson,
    values,
    handleChange,
    handleSubmit,
    disabled,
    handleChangeDate,
    goBack,
    levels,
    setLevel,
    setIndex,
    dataFilterByLevel,
    index,
    handleCloseModal,
    startLesson,
    finishLesson,
    learnerMarkingAbsence,
    handleAbsent,
    handleSubmitAbsentLearner,
    handleCancel,
    editAttendance,
  } = useLessonDetailController();

  const isSupervised = lesson?.type.key === ExerciseContentType.SUPERVISED;

  const lessonExercisesColumns = getLessonExercisesColumn(isSupervised, setIndex, setLevel);

  const date = (values?.date ? new Date(values.date) : '') as Date;

  const isDateBefore = isBefore(date, new Date());

  const disabledDateTimePicker = isDateBefore && !!lesson?.start && !!lesson?.end;

  const startTime = values?.start;
  const endTime = values?.end;

  const startTimeDate = parse(startTime, 'HH:mm', new Date());
  const endTimeDate = parse(endTime, 'HH:mm', new Date());

  const isStartTimeBeforeEndTime = isBefore(startTimeDate, endTimeDate);

  const showStartLesson = isNull(lesson?.action);
  const showFinishLesson = lesson?.action === ClassLessonAction.STARTED;

  return (
    <div>
      <HeaderDetailPage
        title={
          <div>
            <Typography variant="h3" weight={700}>
              {lesson?.name}
            </Typography>
            <Typography style={{ fontSize: '16px', lineHeight: '22px', color: '#808080' }}>
              {lesson?.type.name}
            </Typography>
          </div>
        }
        goBack={goBack}
      />

      <div
        style={{
          margin: '16px 0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
          <div className="wrapper-calendar-input" style={{ width: '30%' }}>
            <CalendarInput
              date={date}
              onChange={handleChangeDate}
              dropdownConfig={
                disabledDateTimePicker
                  ? {
                      dropdownConfig: {
                        disabled: disabledDateTimePicker,
                      },
                    }
                  : undefined
              }
              disabled={disabledDateTimePicker}
            />
          </div>
          <div style={{ display: 'flex', width: '30%', gap: 12 }}>
            <TextInput
              type="time"
              containerStyle={{
                maxWidth: 'auto',
              }}
              value={values.start}
              disabled={!date || disabledDateTimePicker}
              onChange={handleChange}
              name="start"
            />
            <TextInput
              type="time"
              containerStyle={{
                maxWidth: 'auto',
              }}
              value={values.end}
              disabled={!date || disabledDateTimePicker}
              onChange={handleChange}
              name="end"
            />
          </div>
          <div style={{ flex: 1, display: 'flex', gap: 12 }}>
            <Button color="primary" disabled={disabled} onClick={() => handleSubmit()}>
              Save
            </Button>

            {showStartLesson && isSupervised && (
              <Button color="primary" onClick={startLesson}>
                Start lesson
              </Button>
            )}

            {showFinishLesson && isSupervised && (
              <Button color="primary" onClick={finishLesson}>
                Finish lesson
              </Button>
            )}

            {lesson?.action === ClassLessonAction.STOPPED && isSupervised && (
              <Button color="primary" onClick={editAttendance}>
                Edit attendance
              </Button>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6 }}>
          <div style={{ width: '30%' }}></div>
          <div style={{ width: '40%' }}>
            {!isStartTimeBeforeEndTime ? (
              <Typography color={COLOR_CONFIG.red}>Invalid duration</Typography>
            ) : null}
          </div>
          <div></div>
        </div>
      </div>
      <div className={`border-container p-16 pt-0 ${activeKey === LESSON.RESULT ? '' : 'py-0'}`}>
        <CustomTabs>
          <Tabs
            items={tabs}
            activeKey={activeKey}
            onTabClick={onTabClick}
            tabItemStyle={{
              height: 52,
              background: 'transparent',
              width: '50%',
              display: 'flex',
              justifyContent: 'center',
              padding: 0,
            }}
            isLine={true}
          />
        </CustomTabs>
        <div style={{ marginTop: 16 }}>
          {activeKey === LESSON.RESULT ? (
            <LearnResult
              type={LessonAssessmentType.LESSONS}
              learnerResults={learnerResult}
              completedOn={lesson?.completedOn}
              lessonType={lesson?.type.key}
            />
          ) : (
            <LessonExercises
              columns={lessonExercisesColumns}
              data={exercises}
              setIndex={setIndex}
              levels={levels}
              setLevel={setLevel}
              isSupervised={isSupervised}
            />
          )}
        </div>
        <SupervisedVideo
          data={(dataFilterByLevel as any) || exercises}
          index={index}
          handleCloseModal={handleCloseModal}
        />
        <ClassAbsentModal
          handleAbsent={handleAbsent}
          handleSubmitAbsentLearner={handleSubmitAbsentLearner}
          learnerMarkingAbsence={learnerMarkingAbsence}
          handleCancel={handleCancel}
        />
      </div>
    </div>
  );
};
